import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=732077b2&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=ts"
export * from "./IndexPage.vue?vue&type=script&lang=ts"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=732077b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732077b2",
  null
  
)

export default component.exports